import {BapiPrice} from '@aboutyou/backbone/types/BapiProduct';
import {TrackingPrice} from '@aboutyou/legacy-tracking-sdk';
import {SizePrice} from './types';

export const calculateFullPrice = (price: SizePrice): number =>
  (price.withTax || 0) +
  (price.saleReduction?.reductionAmountWithTax || 0) +
  (price.campaignReduction?.reductionAmountWithTax || 0) +
  (price.couponReduction?.reductionAmountWithTax || 0);

export const getTrackingPriceFromBapiPrice = (
  price: Omit<BapiPrice, 'tax' | 'reference'> | undefined,
): TrackingPrice => {
  if (!price) {
    return {
      withTax: 0,
      withoutTax: 0,
      currency: '',
      saleReductionWithTax: 0,
      campaignReductionWithTax: 0,
      fullPrice: 0,
      couponReductionWithTax: 0,
      coinsReductionWithTax: 0,
    };
  }

  return {
    withTax: price.withTax,
    withoutTax: price.withoutTax,
    currency: price.currencyCode || '',
    couponReductionWithTax: 0,
    coinsReductionWithTax: 0,
    fullPrice:
      price.withTax +
      (price.appliedReductions || []).reduce(
        (sum, reduction) => sum + reduction.amount.absoluteWithTax,
        0,
      ),
    saleReductionWithTax: (price.appliedReductions || []).reduce(
      (reductionSum, reduction) => {
        if (reduction.category === 'sale') {
          return reductionSum + reduction.amount.absoluteWithTax;
        }

        return reductionSum;
      },
      0,
    ),
    campaignReductionWithTax: (price.appliedReductions || []).reduce(
      (reductionSum, reduction) => {
        if (reduction.category === 'campaign') {
          return reductionSum + reduction.amount.absoluteWithTax;
        }

        return reductionSum;
      },
      0,
    ),
  };
};

export const getTrackingPrice = (price: SizePrice | undefined) => {
  if (!price) {
    return {
      withTax: 0,
      withoutTax: 0,
      currency: '',
      saleReductionWithTax: 0,
      campaignReductionWithTax: 0,
      fullPrice: 0,
      couponReductionWithTax: 0,
      coinsReductionWithTax: 0,
    };
  }

  return {
    withTax: price.withTax,
    withoutTax: price.withTax - price.tax,
    currency: price.currencyCode || '',
    saleReductionWithTax: price?.saleReduction?.reductionAmountWithTax || 0,
    campaignReductionWithTax:
      price?.campaignReduction?.reductionAmountWithTax || 0,
    fullPrice: calculateFullPrice(price),
    couponReductionWithTax: 0,
    coinsReductionWithTax: 0,
  };
};
